module.exports = __webpack_public_path__ + "static/media/question-mark.28dab8e7.png";